/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityVersion, ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { SfMeetingDto } from './meeting.dto';

export const SalesFolderStatus = createEnum('SALES_FOLDER_STATUS', {
  Active: 1,
  Completed: 2,
  WillNotComplete: 3,
});

export type SalesFolderStatus = EnumSet<typeof SalesFolderStatus>;

export type SalesFolderShortDto = {
  salesFolderId: ID;
  name: string;
  created: Date;
  version?: EntityVersion;
  isNew: boolean;
};

export type SalesFolderRfqGeneralDto = {
  salesFolderId: ID;
  contactId: ID;
  customerName: string;
  salesFolderName: string;
  owner1: string;
  owner2: string;
  owner3: string;
  email1: string;
  email2: string;
  email3: string;
  isSigner1: boolean;
  isSigner2: boolean;
  isSigner3: boolean;
  showOn: boolean;
  description: string;
  validDays: number;
  paragraph1: string;
  paragraph2: string;
  memo: string;
  status: SalesFolderStatus;
  notProceedingReason?: number | string;
  isParagraph1Changed: boolean;
  isParagraph2Changed: boolean;
  isValidDaysChanged: boolean;
};

export type SalesFolderDto = {
  salesFolderId: ID;
  name: string;
  priority: number;
  created: Date;
  followUp: Date;
  status: SalesFolderStatus;
  notProceedingReason?: number | string;
  stage: number;
  memo: string;
  meetings: SfMeetingDto[];
  jobId?: ID;
  jobNumber?: number;
  jobDepositDate?: Date;
  jobContractDate?: Date;
  jobBaseDesignId?: ID;
  jobBaseDesignName?: string;
  jobMemo?: string;
  isDppJob: boolean;
  completedByName?: string;
  earliestActivityId?: ID;
};

export type SalesFolderCompleteDto = {
  quotationId: string;
  baseDesignId?: ID;
  description: string;
  unitsCount: number;
  memo: string;
};

export type JobDppCreateRequestDto = {
  baseDesignId: ID;
  estimateCost: number;
  memo: string;
  unitsCount: number;
  siteId: ID;
};
